import request from '@/utils/request'

function params(query) {
    const cookiestr = document.cookie
    const params = {
        distinctId: '',
        deviceId: '',
        userId: '',
    }

    let isInApp =
        cookiestr.indexOf('driver-token') > -1 ||
        cookiestr.indexOf('distinct-id') > -1 ||
        cookiestr.indexOf('device-id') > -1 ||
        cookiestr.indexOf('userId') > -1
    if (isInApp && cookiestr) {
        let cookieList = cookiestr.split(';')
        cookieList.forEach(item => {
            let itemArr = item.split('=')
            if (itemArr[0].trim() === 'distinct-id') {
                params.distinctId = itemArr[1] || null
            }
            if (itemArr[0].trim() === 'device-id') {
                params.deviceId = itemArr[1] || null
            }
            if (itemArr[0].trim() === 'userId') {
                params.userId = itemArr[1] || null
            }
        });
        let url = window.location.origin + window.location.pathname;
        const ps = [];
        Object.keys(params).forEach( item => ps.push(item + '=' + params[item]));
        window.history.pushState(null, null, url + '?' + ps.join('&'))

    } else {
        Object.keys(params).forEach(item => {
            if (query[item]) {
                params[item] = query[item]
            }
            if (params[item] === '' || typeof params[item] === 'undefined') {
                delete params[item]
            }
        })
    }
    return params
}

export default function getTPDriverState2020(query) {
    return request({
        url: '/tp/annualReport',
        baseURL: process.env.VUE_APP_TP_YEAR_REVIEW_2020,
        method: 'get',
        params: params(query),
    }).then(res => {
        if (res.status === 200 && res.data.code === 200) {
            return { ...res.data.data, enable: true }
        } else {
            return { enable: false }
        }
    })
}
